'use strict';

define('search',['jquery'], function ($) {

    var
        $searchField             = $('#search-field'),
        $searchButton            = $('#js-search-button');

    var attachEvents = function() {
        $searchButton.on('click', function() {
          doSearch();
        });

        $searchField.on('keydown', function(event) {
            if(event.keyCode === 13){
              doSearch();
            }
          });
      };

    var doSearch = function() {
        var searchText = $searchField.val().trim();
        if(searchText === ''){
          return;
        }
        window.location.href = '/search?q='+encodeURIComponent(searchText);
      };

    var setFocusOnSearch = function() {
        $searchField.val('');
        $searchField.focus();
      };

    var initialize = function() {
        attachEvents();
      };

    return {
        init: initialize
      };
  });
